
import { defineComponent, ref } from "vue";
import KTDatatable from "@/components/kt-datatable/KTDatatable.vue";
import Masthead from "@/components/custom/layout/Masthead.vue";

export default defineComponent({
  components: { Masthead },
  setup() {
    const headerConfig = ref([
      {
        name: "Bil.",
        key: "bil",
        sortable: true,
      },
      {
        name: "Urusan",
        key: "urusan",
        sortable: true,
      },
      {
        name: "Nama Pentadbir",
        key: "nama-pentadbir",
        sortable: true,
      },
      {
        name: "Nombor Telefon",
        key: "nombor-telefon",
        sortable: true,
      },
      {
        name: "Alamat Emel (@anm.gov.my)",
        key: "alamat-emel",
        sortable: true,
      },
    ]);
    return { headerConfig };
  },
});
